import { AdvancedFilterPanel } from '@/components/common/AdvancedFilter';
import { getFilterPanelProps, type UrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import { getDateFromToFilterFields } from '@/utils/filterFields';
import { SURVEY_STATUS_LABELS } from '../constants/survey.constants';
import { SURVEY_STATUS } from '../types/survey.types';

const START_DATE_FILTER_KEY = 'from';
const END_DATE_FILTER_KEY = 'to';

const STATUS_OPTIONS = SURVEY_STATUS.map((status) => ({
  value: status,
  label: SURVEY_STATUS_LABELS[status],
}));

interface SurveyFilterPanelProps {
  filters: UrlSyncedFilters;
}

export function SurveyFilterPanel({ filters }: SurveyFilterPanelProps) {
  return (
    <AdvancedFilterPanel
      fields={[
        {
          key: 'state',
          label: 'Status',
          type: 'select',
          placeholder: 'All',
          options: STATUS_OPTIONS,
        },
        ...getDateFromToFilterFields({
          fromKey: START_DATE_FILTER_KEY,
          toKey: END_DATE_FILTER_KEY,
        }),
      ]}
      {...getFilterPanelProps(filters)}
    />
  );
}
